import { db, firebaseAuth } from './firebaseConfig';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import EntityEnum from './EntityEnum';
import { userReference, groupReference } from './user';
import { executeAndFormat, deleteItem, updateItem, addItem } from './firebaseFunctions';


export const getEvaluation = ({ scope, hasFullPower, user, id }) => {
    let table = db.collection("Quiz").where("active", "==", true).where("isEvaluation", "==", true);

    if(!hasFullPower){
        table = table.where("user", "==", userReference(user));
    }

    if (scope && scope.value) {
        table = table.where("group", "==", groupReference(scope));
    } else if (id) {
        table = db.collection("Quiz").doc(id);
    } else {
        throw new Error(I18n[keyEnum.groupFieldRequired]);
    }

    return executeAndFormat(table, [{ key: 'group'}, {key: 'user'}, {key: 'template'}], [], (quizItem => {
        quizItem.date = { ...quizItem.date };
    }));
}

export const deleteEvaluation = async (id) => {
    return deleteItem("Quiz", id);
}

export const addOrUpdate = async (item) => {
    let { id, group, user } = item;

    const data = { ...item };
    if (id) {
        data['id'] = id;
    }
    if (group) {
        data['group'] = groupReference(group);
    }

    if (user) {
        data['user'] = userReference(user);
    }

    if (id) {
        return updateItem("Quiz", data);
    } else {
        return addItem("Quiz", { ...data, date: new Date() }).then(item => {
            return ({...item, user})
        });
    }
}



/**
 * const users = db.collection(EntityEnum.user);
    const query = users.where('invite', '==', true);

    return query.get().then(snapshot => {
        if (snapshot.empty) {
            return;
        } else {
            snapshot.docs.forEach(document => {
                if (document.exists && document.id === id) {
                    return document;
                } else {
                    throw new Error(I18n[keyEnum.inviteExpired]);
                }
            });
            return;
        }
    })
 */